import { memo } from 'react';
import Pds08Locale from 'locale/en/pds08.json';
import { createGlobalStyle } from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

const ModalPDS08FactsStyles = createGlobalStyle`
  #modal-pds08-facts {
  .container {
    display: flex;
    flex-direction: column;
  }

  .head {
    border-bottom: 1px solid var(--outline-primary);
    padding-bottom: 4px;

    @media ${mqLargeMin} {
      border-bottom-width: 2px;
      padding-bottom: 80px;
    }
  }

  .spaced {
    padding: 12px 0;
  }
    .spaced--bottom {
      padding-bottom: 12px;
    }

    .spaced--extra {
      padding: 24px 0 12px;

      @media ${mqLargeMin} {
        padding: 44px 0 12px;
      }
    }

    .spaced--end {
      padding: 12px 0;
      padding-bottom: 30px;

      @media ${mqLargeMin} {
        padding-bottom: 50px;
      }
    }

  .smaller {
    font-size: 12px;

    @media ${mqLargeMin} {
      font-size: 14px;
    }
  }

  .border {
    border-bottom: 1px solid var(--outline-neutral);
  }

  .border--strong {
    border-bottom: 1.5px solid var(--outline-primary);
  }

  .border--wide {
    border-bottom-width: 3px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    padding-right: 12px;

    p:nth-child(2) {
      text-align: right;
      padding-left: 20px;
    }
  }

  h2 {
    font-weight: 500;
    font-size: 26px;
    margin: 10px 0 0;

    @media ${mqLargeMin} {
      font-size: 50px;
      margin: 20px 0;
    }
  }

  p,
  strong,
  td,
  th,
  i,
  span {
    font-size: 14px;

    @media ${mqLargeMin} {
      font-size: 16px;
    }
  }

  table {
    margin-top: 30px;
    border-spacing: 0px;
  }

  th,
  td {
    border-bottom: 1px solid var(--outline-neutral);

    &:nth-child(1) {
      text-align: left;
    }

    &:nth-child(2) {
      text-align: center;
    }

    &:nth-child(3) {
      text-align: center;
    }

    &:nth-child(4) {
      text-align: right;
      padding-right: 12px;
      width: 30%;

      @media ${mqLargeMin} {
        width: 250px;
      }
    }
  }

  th {
    padding-bottom: 4px;
  }

  td {
    padding: 12px 0;
  }

  i {
    font-weight: 300;
    max-width: 680px;
    display: block;
  }

  p > span {
    max-width: 680px;
    display: block;
  }
}
`;

const ModalPDS08Facts = () => (
  <>
    <ModalPDS08FactsStyles />
    <div className='head'>
      <div className='title'>{Pds08Locale.page_title}</div>
      <span>{Pds08Locale.facts}</span>
    </div>
    <div>
      <h2>Supplement Facts</h2>
      <p>Serving Size 1 Sachet (6.30g powder)</p>
      <p>Servings Per Container 30</p>
    </div>
    <table>
      <thead>
        <tr>
          <th>Amount Per Serving</th>
          <th />
          <th>%DV for Children 3 Yrs*</th>
          <th>%DV for Children 4 Yrs & Up‡</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Calories</td>
          <td>15</td>
          <td />
          <td />
        </tr>
        <tr>
          <td>Total Carbohydrate</td>
          <td>6g</td>
          <td>4%*</td>
          <td>2%‡</td>
        </tr>
        <tr>
          <td>Dietary Fiber</td>
          <td>5g</td>
          <td>33%*</td>
          <td>18%‡</td>
        </tr>
        <tr>
          <td>Total Sugars</td>
          <td>&#60;1g</td>
          <td>-</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
    <p className='spaced border--strong border--wide'>
      Includes 0g Added Sugars
    </p>
    <p className='spaced--extra border'>
      <strong>Probiotic Strains</strong>
    </p>
    <div className='spaced flex border'>
      <p>
        <strong>Gastrointestinal Immunity / Health Probiotic Blendº</strong>
      </p>
      <p>
        <strong>168mg / 19.5 Billion AFU</strong>
      </p>
    </div>
    <p className='spaced border'>
      <i className='smaller'>
        Lacticaseibacillus rhamnosus SD-GG-IT, Lactobacillus acidophilus
        SD-NCFM-US, Bifidobacterium lactis SD-BI07-US, Bifidobacterium breve
        SD-BR3-IT
      </i>
    </p>
    <div className='spaced flex border'>
      <p>
        <strong>Respiratory Health Probiotic Blendº</strong>
      </p>
      <p>
        <strong>30mg / 3.5 Billion AFU</strong>
      </p>
    </div>
    <p className='spaced border'>
      <i className='smaller'>
        Bifidobacterium breve SD-B632-IT, Ligilactobacillus salivarius
        SD-LS01-IT
      </i>
    </p>
    <div className='spaced flex border'>
      <p>
        <strong>Dermatological Health Probiotic Blendº</strong>
      </p>
      <p>
        <strong>15mg / 1.5 Billion AFU</strong>
      </p>
    </div>
    <p className='spaced border'>
      <i className='smaller'>
        Bifidobacterium lactis SD-CECT8145-SP, Bifidobacterium longum
        SD-CECT7347-SP, Lacticaseibacillus casei SD-CECT9104-SP
      </i>
    </p>
    <div className='spaced flex border'>
      <p>
        <strong>Total Probiotic Enumeration</strong>
      </p>
      <p>
        <strong>24.5 Billion AFU</strong>
      </p>
    </div>
    <div className='spaced flex border'>
      <p>
        MAOS Microbiota-Accessible Oligomeric Substrates™ Prebiotic
        <i className='smaller'>
          Molecular weight profiled inulin and fructooligosaccharides from
          chicory (Cichorium intybus) root.
        </i>
      </p>
      <p>6.09g</p>
    </div>
    <ul className='spaced border'>
      <li className='smaller'>
        *Percent Daily Value (%DV) is based on a 1,000 calorie diet.
      </li>
      <li className='smaller'>
        ‡Percent Daily Value (%DV) is based on a 2,000 calorie diet.
      </li>
      <li className='smaller'>Daily Value not established.</li>
      <li className='smaller'>
        AFU = Active Fluorescent Units (viable probiotic cell count) via flow
        cytometry. Probiotics remain active without refrigeration.
      </li>
    </ul>
    <div className='spaced border--strong'>
      <p>
        <span>
          <strong>Other Ingredients:</strong> Glyceryl fatty acid esters (for
          microencapsulation of certain probiotic strains).
        </span>
      </p>
      <p>
        <span>
          <strong>For Optimal Results:</strong> Pour contents of 1 sachet into a
          room temperature food or drink (e.g., yogurt, fruit puree, or water)
          and mix well. Once mixed, avoid heating food or drink. 1 sachet daily.
          No refrigeration required.
        </span>
      </p>
    </div>

    <div className='border--strong'>
      <p className='spaced smaller'>
        <span>
          PDS-08® is developed by Seed Health, Inc., Venice, CA 90291.
          Composition and methods are patent pending (PCT/US2022/015506;
          PCT/US2022/015509; U.S. Pat. App. 29/831,918). Seed® and PDS-08® are
          registered trademarks, and BacTrac™ and MAOS Microbiota-Accessible
          Oligomeric Substrates™ are trademarks of Seed Health, Inc.
        </span>
      </p>
      <p className='spaced--bottom smaller'>
        <span>
          Intended for daily use by persons between the ages of 3–17 years. Use
          only under the supervision of a parent, guardian, or health
          practitioner.
        </span>
      </p>
      <p className='spaced--bottom smaller'>
        <span>Do not exceed the stated recommended daily dose.</span>
      </p>
      <p className='spaced--bottom'>
        <span>
          <strong className='smaller'>
            Keep out of reach of children under 3 years of age.
          </strong>
        </span>
      </p>
    </div>
    <div className='spaced--end'>
      <p className='smaller'>
        ºThese statements have not been evaluated by the Food and Drug
        Administration. This product is not intended to diagnose, treat, cure,
        or prevent any disease.
      </p>
    </div>
  </>
);

export default memo(ModalPDS08Facts);
